import React from 'react';
import Header from '../Header';
import Footer from '../Footer';
import './ContactPage.css';

const ContactPage: React.FC = () => {
  return (
    <div className="contact-page">
      <div className="contact-animated-background">
        <div className="contact-bg-gradient-1"></div>
        <div className="contact-bg-gradient-2"></div>
        <div className="contact-bg-gradient-3"></div>
      </div>
      
      <Header />
      
      <main className="contact-main-content">
        <section className="contact-hero-section">
          <div className="contact-hero-content">
            <h1 className="contact-hero-title">Contact Us</h1>
            <p className="contact-hero-subtitle">Get in touch with our team</p>
          </div>
        </section>
        
        <section className="contact-content-section">
          <div className="contact-cards-container">
            <div className="contact-info-card">
              <div className="contact-info-content">
                <h2>Visit Our Showroom</h2>
                <div className="contact-details">
                  <div className="detail-group">
                    <h3>Address</h3>
                    <p>79 Waterworks Road</p>
                    <p>Worcester</p>
                    <p>WR1 3EZ</p>
                    <p>United Kingdom</p>
                  </div>
                  
                  <div className="detail-group">
                    <h3>Phone</h3>
                    <p>
                      <a href="tel:01905616006">01905 616006</a>
                    </p>
                  </div>
                  
                  <div className="detail-group">
                    <h3>Email</h3>
                    <p>
                      <a href="mailto:sales@dmbrands.co.uk">sales@dmbrands.co.uk</a>
                    </p>
                  </div>
                  
                  <div className="detail-group">
                    <h3>Business Hours</h3>
                    <p>Monday - Friday: 9:00 AM - 5:00 PM</p>
                    <p>Saturday: By Appointment</p>
                    <p>Sunday: Closed</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="contact-form-card">
              <div className="contact-form-content">
                <h2>Send us a message</h2>
                <form className="contact-form">
                  <div className="form-group">
                    <label htmlFor="name">Name</label>
                    <input type="text" id="name" name="name" required />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input type="email" id="email" name="email" required />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="company">Company</label>
                    <input type="text" id="company" name="company" />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="subject">Subject</label>
                    <input type="text" id="subject" name="subject" required />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="message">Message</label>
                    <textarea id="message" name="message" rows={5} required></textarea>
                  </div>
                  
                  <button type="submit" className="submit-btn">
                    Send Message
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default ContactPage;